var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-button back-btn btn btn--secondary btn--ghost btn--small has-icon",class:{disabled:_vm.disabledBackBtn,hide:!_vm.visibleNextBtn},on:{"click":_vm.handleBack}},[_c('div',{staticClass:"icon back"}),_vm._v(" "+_vm._s(_vm.$t("back"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }